import { useState } from "react";
import { convertThenFormat } from "../../../components/common-data/Converts";
import Modal from "react-modal";
import CoinDetails from "./CoinSpentDetails";

const CoinCard = ({
  category_name,
  total_coins,
  total_inr_value,
  total_user,
  category_id,
  userInfoData,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const onCloseModalvalues = () => {
    setModalOpen(false);
  };

  const handleShowDetails = () => {
    setModalOpen(true);
  };

  return (
    <>
      <div
        className="coin__Card"
        onClick={() => handleShowDetails(category_id)}
      >
        <h4>{category_name || "NA"}</h4>
        <div className="coinCard__bottomText">
          <>
            <span>{total_coins}</span>
            <small>(₹{convertThenFormat(total_inr_value)})</small>
            <br />
            <small className="">{total_user} Members</small>
          </>
        </div>
      </div>

      <Modal
        isOpen={modalOpen}
        closeModal={onCloseModalvalues}
        contentLabel="Coin Details"
        ariaHideApp={false}
      >
        <CoinDetails
          category_id={category_id}
          userInfoData={userInfoData}
          onClose={onCloseModalvalues}
        />
      </Modal>
    </>
  );
};

export default CoinCard;
